var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.895,
    height: 26.775,
    viewBox: "0 0 30.895 26.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_63",
    "data-name": "Trazado 63",
    d: "M17.578,3.221a1.04,1.04,0,0,0-1.279,0L1.5,14.76l1.28,1.619L4.59,14.968V27.717a2.064,2.064,0,0,0,2.06,2.06h20.6a2.064,2.064,0,0,0,2.06-2.06V14.977l1.809,1.411,1.28-1.619Zm1.429,24.5H14.888V19.478h4.119Zm2.06,0V19.478a2.062,2.062,0,0,0-2.06-2.06H14.888a2.062,2.062,0,0,0-2.06,2.06v8.239H6.649V13.363l10.3-8.023,10.3,8.033V27.717Z",
    transform: "translate(-1.5 -3.001)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c7ecd7e4a1a1ed94a310c8b19b888f6c.svg";
export { ForwardRef as ReactComponent };